import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  Space,
  Col,
  Row,
  message,
  Select,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { ReactComponent as EditIcon } from "../../../assets/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/delete-icon.svg";
import { ReactComponent as SaveIcon } from "../../../assets/save-icon.svg";
import { ReactComponent as CrossIcon } from "../../../assets/cross-icon.svg";
import SpinnerComponent from "../../../components/spinner";
import _ from "lodash";
// import { arrayMoveImmutable } from 'array-move';
// import DragDropIcon from '../../../assets/dragdropicon.png';
import {
  createCurriculum,
  deleteCurriculum,
  isCurriculumAdding,
  updateCurriculum,
} from "../redux/actions";
import { progressStatuses, progressStatusesObj } from "./utils";
// import {
//   SortableContainer,
//   SortableElement,
//   SortableHandle,
// } from 'react-sortable-hoc';

// const SortableItem = SortableElement((props) => <tr {...props} />);
// const SortableBody = SortableContainer((props) => <tbody {...props} />);
// const DragHandle = SortableHandle(() => <img alt='' src={DragDropIcon} />);
const { Option } = Select;

var isUpdating = false;

const CurriculumsTable = ({ allCurriculums, currentUserObj }) => {
  const [editingLoading, setEditingLoading] = useState(false);
  const [editingKey, setEditingKey] = useState("");
  const [search, setSearch] = useState({});
  const [req, setReq] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const ref = useRef(null);
  const isEditing = (record) => record._id === editingKey;

  //   const { curriculums, fetchingLoading, updateLoading, isAdding } = useSelector(
  //     (state) => state.roomsReducer
  //   );

  const { curriculums, isAdding, updateLoading, fetchingLoading } = useSelector(
    (state) => state.curriculumStudentReducer
  );

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 500)
  );

  useEffect(() => {
    // dispatch(fetchRooms());

    return () => {
      //   dispatch(isCurriculumAdding(false));
    };
  }, []);

  useEffect(() => {
    setEditingLoading(updateLoading);
    // if (!updateLoading) {
    //   setEditingKey('');
    // }
  }, [updateLoading]);

  useEffect(() => {
    setData(curriculums);
  }, [curriculums]);

  useEffect(() => {
    let filteredData = curriculums;

    if (search?.curriculum_id?.length > 0) {
      filteredData = filteredData.filter((el) =>
        el?.curriculum_id?.includes(search.curriculum_id)
      );
    }

    if (search?.competency_rate?.length > 0) {
      filteredData = filteredData.filter((el) =>
        el.competency_rate
          .toString()
          ?.includes(search.competency_rate?.toString())
      );
    }

    if (search?.profile_risk?.length > 0) {
      filteredData = filteredData.filter((el) =>
        el.profile_risk
          ?.toLowerCase()
          ?.includes(search.profile_risk?.toLowerCase())
      );
    }

    if (search?.status?.length > 0) {
      filteredData = filteredData.filter((el) => el.status === search.status);
    }

    if (search?.progress_status?.length > 0) {
      filteredData = filteredData.filter(
        (el) => el.progress_status === search.progress_status
      );
    }

    setData(filteredData);
  }, [req]);

  const curriculumsSelectOptions = allCurriculums
    ?.filter((el) => el.deleted_status === "active")
    ?.filter(
      (el) =>
        !data.find(
          (d) =>
            d?.curriculum_id === el.value &&
            d.status === "inprogress" &&
            editingKey !== d?.curriculum_id
        )
    );

  const onSuccess = () => {
    setEditingKey("");
  };

  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    let inputNode = (
      <Input
        placeholder={`Insert ${dataIndex}`}
        ref={dataIndex === "code" ? ref : null}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            save(record._id);
          }
        }}
      />
    );

    if (dataIndex === "curriculum_id") {
      inputNode = (
        <Select
          showSearch
          className={`deleted-status-selector`}
          style={{ width: "100%", height: "30px" }}
          getPopupContainer={() =>
            document.getElementsByClassName(
              "ant-layout-content layout-content site-layout-background custom-textarea"
            )[0]
          }
          dropdownClassName="select-dropdown-custom"
          size="small"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          // onChange={handleUpdateSite}
          placeholder="Select Curriculum"
          optionLabelProp="label"
        >
          {curriculumsSelectOptions
            ?.filter((el) => el.deleted_status === "active")
            .map(({ label, value }) => {
              return (
                <Option value={value} key={value} label={label}>
                  {label || ""}
                </Option>
              );
            })}
        </Select>
      );
    }

    if (dataIndex === "status") {
      inputNode = (
        <Select
          showSearch
          className={`deleted-status-selector`}
          style={{ width: "100%", height: "30px" }}
          getPopupContainer={() =>
            document.getElementsByClassName(
              "ant-layout-content layout-content site-layout-background custom-textarea"
            )[0]
          }
          dropdownClassName="select-dropdown-custom"
          size="small"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          // onChange={handleUpdateSite}
          placeholder="Select Curriculum"
          optionLabelProp="label"
        >
          {[
            { label: "In progress", value: "inprogress" },
            { label: "Passed", value: "passed" },
            { label: "Failed", value: "failed" },
            { label: "Cancelled", value: "cancelled" },
          ]?.map(({ label, value }) => {
            return (
              <Option
                value={value}
                key={value}
                label={label.toLocaleUpperCase()}
              >
                {label.toUpperCase() || ""}
              </Option>
            );
          })}
        </Select>
      );
    }

    if (dataIndex === "progress_status") {
      inputNode = (
        <Select
          showSearch
          className={`deleted-status-selector`}
          style={{ width: "100%", height: "30px" }}
          getPopupContainer={() =>
            document.getElementsByClassName(
              "ant-layout-content layout-content site-layout-background custom-textarea"
            )[0]
          }
          dropdownClassName="select-dropdown-custom"
          size="small"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          // onChange={handleUpdateSite}
          placeholder="Select Progress Status"
          optionLabelProp="label"
        >
          {progressStatuses.map(({ label, value }) => {
            return (
              <Option
                value={value}
                key={value}
                label={label.toLocaleUpperCase()}
              >
                {label.toUpperCase() || ""}
              </Option>
            );
          })}
        </Select>
      );
    }

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Required!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const edit = (record) => {
    dispatch(isCurriculumAdding(true));

    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record._id);
    setTimeout(() => {
      ref.current?.focus();
    }, 300);
  };

  const cancel = (record) => {
    dispatch(isCurriculumAdding(false));
    isUpdating = false;
    form.resetFields();
    setEditingKey("");
    if (record?.isAdd) {
      return setData((data) => data.filter((el) => el._id !== record._id));
    } else {
      setData(data);
    }
  };

  const save = async (id) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => id === item._id);
      if (index > -1) {
        const item = newData[index];
        if (item?.isAdd) {
          form.submit();
        } else {
          let data = { ...item, ...row };
          if (isAlreadyExist(data) && data.status === "inprogress") {
            return message.error("Curriculum already is in progress!");
          }
          const { curriculum_id, _id, status, progress_status } = data;
          dispatch(
            updateCurriculum({
              curriculum_student_id: _id,
              user_id: currentUserObj._id,
              curriculum_id,
              status,
              progress_status,
              onSuccess,
            })
          );
        }
      }
    } catch (errInfo) {
      if (errInfo?.values?.curriculum_id === "") {
        message.error("Curriculum should not be blank!");
      }
    }
  };

  const handleSuccess = () => {
    form.resetFields();
    setEditingKey("");
    dispatch(isCurriculumAdding(false));
    isUpdating = false;
  };

  const handleDelete = (record) => {
    setEditingKey(record._id);
    dispatch(
      deleteCurriculum({ id: record.curriculum_student_id, handleSuccess })
    );
  };

  const handleAdd = () => {
    dispatch(isCurriculumAdding(true));
    isUpdating = false;
    let _id = Math.floor(Math.random() * 1122123456);
    const newData = {
      _id,
      isAdd: true,
    };
    setData((data) => [newData, ...data]);
    setEditingKey(_id);
    edit(newData);
  };

  const isAlreadyExist = (record) => {
    const { curriculum_id } = record;

    const alreadyExist = data.filter(
      (el) => el?.curriculum_id === curriculum_id && el.status === "inprogress"
    );

    return alreadyExist.length > 0 && record._id !== alreadyExist[0]?._id
      ? true
      : false;
  };

  const handleFinish = (values) => {
    const { curriculum_id, progress_status } = values;

    if (isAlreadyExist(values)) {
      return message.error("Curriculum already exist!");
    }

    dispatch(
      createCurriculum({
        curriculum_id: curriculum_id.trim(),
        _id: editingKey,
        user_id: currentUserObj._id,
        progress_status,
        onSuccess,
      })
    );
  };

  const searchInput = (key) => (
    <Input
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        setSearch({
          ...search,
          [key]: e.target.value,
        });
        debouncedCallApi();
      }}
    />
  );

  const curriculumsOptions = allCurriculums?.filter((el) =>
    curriculums.find((d) => d?.curriculum_id === el.value)
  );

  const columns = [
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Curriculum Name</div>
            <div key={"1"}>
              <Select
                style={{
                  width: "100%",
                  textTransform: "capitalize",
                }}
                size="small"
                onClick={(e) => e.stopPropagation()}
                allowClear={true}
                readOnly={true}
                className="Select Gender"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                showSearch
                placeholder=""
                optionFilterProp="children"
                onChange={(e) => {
                  setSearch({
                    ...search,
                    curriculum_id: e,
                  });
                  debouncedCallApi();
                }}
                optionLabelProp="label"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {curriculumsOptions?.map(({ label, value }) => {
                  return (
                    <Option value={value} label={label}>
                      {label || ""}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "curriculum_id",
      key: "curriculum_id",
      width: "30%",
      editable: !isUpdating,
      align: "left",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      render: (name, record) => {
        return (
          <div style={{ paddingLeft: "12px" }}>
            {record?.name?.toUpperCase()}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Competency Rate</div>
            <div>{searchInput("competency_rate")}</div>
          </div>
        );
      },
      dataIndex: "competency_rate",
      key: "competency_rate",
      width: "15%",
      editable: false,
      align: "center",
      sorter: (a, b) => {
        const valA = a.competency_rate
          ? String(a.competency_rate).toLowerCase()
          : "";
        const valB = b.competency_rate
          ? String(b.competency_rate).toLowerCase()
          : "";
        return valA.localeCompare(valB);
      },
      render: (competency_rate) => {
        return <div style={{ paddingLeft: "12px" }}>{competency_rate}</div>;
      },
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Profile risk</div>
            <div key={"1"}>
              <Select
                style={{
                  width: "100%",
                  textTransform: "capitalize",
                }}
                size="small"
                onClick={(e) => e.stopPropagation()}
                allowClear={true}
                readOnly={true}
                className="Select Gender"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                showSearch
                placeholder=""
                optionFilterProp="children"
                onChange={(e) => {
                  setSearch({
                    ...search,
                    profile_risk: e,
                  });
                  debouncedCallApi();
                }}
                optionLabelProp="label"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {["low", "medium", "high"]?.map((el) => {
                  return (
                    <Option value={el} label={el}>
                      {el?.toUpperCase() || ""}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "profile_risk",
      key: "profile_risk",
      width: "15%",
      editable: false,
      align: "left",
      sorter: (a, b) => a.profile_risk?.localeCompare(b.profile_risk),
      render: (profile_risk) => {
        return (
          <div style={{ paddingLeft: "12px" }}>
            {profile_risk?.toUpperCase()}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Status</div>
            <div key={"1"}>
              <Select
                style={{
                  width: "100%",
                  textTransform: "capitalize",
                }}
                size="small"
                onClick={(e) => e.stopPropagation()}
                allowClear={true}
                readOnly={true}
                className="Select Gender"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                showSearch
                placeholder=""
                optionFilterProp="children"
                onChange={(e) => {
                  setSearch({
                    ...search,
                    status: e,
                  });
                  debouncedCallApi();
                }}
                optionLabelProp="label"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {[
                  { label: "In progress", value: "inprogress" },
                  { label: "Passed", value: "passed" },
                  { label: "Failed", value: "failed" },
                  { label: "Cancelled", value: "cancelled" },
                ]?.map(({ label, value }) => {
                  return (
                    <Option value={value} label={label}>
                      {label.toUpperCase()}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "status",
      key: "status",
      width: "15%",
      editable: isUpdating,
      align: "left",
      sorter: (a, b) => a.status?.localeCompare(b.status),
      render: (status) => {
        const updatedStatus = status === "inprogress" ? "In Progress" : status;
        return (
          <div style={{ paddingLeft: "12px" }}>
            {updatedStatus?.toUpperCase()}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">Progress Status</div>
            <div key={"1"}>
              <Select
                style={{
                  width: "100%",
                  textTransform: "capitalize",
                }}
                size="small"
                onClick={(e) => e.stopPropagation()}
                allowClear={true}
                readOnly={true}
                className="Select Gender"
                dropdownClassName="select-dropdown-custom"
                getPopupContainer={() =>
                  document.getElementsByClassName(
                    "ant-layout-content layout-content site-layout-background custom-textarea"
                  )[0]
                }
                showSearch
                placeholder=""
                optionFilterProp="children"
                onChange={(e) => {
                  setSearch({
                    ...search,
                    progress_status: e,
                  });
                  debouncedCallApi();
                }}
                optionLabelProp="label"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {progressStatuses?.map(({ label, value }) => {
                  return (
                    <Option value={value} label={label}>
                      {label.toUpperCase()}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
        );
      },
      dataIndex: "progress_status",
      key: "progress_status",
      width: "15%",
      editable: true,
      align: "left",
      sorter: (a, b) => a.progress_status?.localeCompare(b.progress_status),
      render: (progress_status) => {
        return (
          <div style={{ paddingLeft: "12px" }}>
            {progressStatusesObj[progress_status]?.toUpperCase()}
          </div>
        );
      },
    },
    {
      title: "",
      key: "action",
      dataIndex: "",
      width: "10%",
      align: "center",
      render: (_, record) => {
        const editable = isEditing(record);
        let shouldUpdate = ["inprogress", "cancelled"].includes(record.status);

        return editable ? (
          editingLoading && editingKey === record._id ? (
            <SpinnerComponent fontSize={14} />
          ) : (
            <Space size={20} align="center">
              <SaveIcon
                className="custom-icon"
                onClick={() => save(record._id)}
              />
              <Popconfirm
                title="Sure to cancel?"
                onConfirm={() => cancel(record)}
              >
                <CrossIcon
                  style={{ height: "20px", width: "20px" }}
                  className="custom-icon"
                />
              </Popconfirm>
            </Space>
          )
        ) : (
          <Space size={20} align="center">
            {/* {shouldUpdate && ( */}
            <EditIcon
              className={`custom-icon ${isAdding ? "disable-icon" : ""}`}
              disabled={editingKey !== ""}
              onClick={() => {
                if (!isAdding) {
                  edit(record);
                  isUpdating = true;
                }
              }}
            />
            {/* )} */}
            {/* {data.length >= 1 &&
              (isAdding ? (
                <DeleteIcon className={`custom-icon disable-icon`} />
              ) : (
                <Popconfirm
                  title='Are you sure you want to delete this type?'
                  onConfirm={() => handleDelete(record)}
                  okText='Yes'
                  cancelText='No'
                >
                  <DeleteIcon className='custom-icon' />
                </Popconfirm>
              ))} */}
          </Space>
        );
      },
    },
    // {
    //   title: 'Order',
    //   dataIndex: 'order',
    //   key: 'order',
    //   width: '15%',
    //   className: 'drag-visible',
    //   render: (order, record) => {
    //     const { status_type } = record;
    //     let canDelete = status_type === 'not-selected' ? false : true;
    //     if (!canDelete) {
    //       return;
    //     }

    //     if (isAdding) {
    //       return <img alt='' className='disable-icon' src={DragDropIcon} />;
    //     }

    //     return !Boolean(editingKey) && canUpdate && <DragHandle />;
    //   },
    // },
  ];

  // const onSortEnd = ({ oldIndex, newIndex }) => {
  //   const { status_type } = data[newIndex];

  //   let shouldNotReorder = status_type !== 'not-selected' ? false : true;

  //   if (shouldNotReorder) {
  //     return setData((prevData) => prevData);
  //   }

  //   if (oldIndex !== newIndex) {
  //     const newData = arrayMoveImmutable(
  //       data.slice(),
  //       oldIndex,
  //       newIndex
  //     ).filter((el) => !!el);

  //     dispatch(updateRoomsOrder(newData));
  //   }
  // };

  // const DraggableContainer = (props) => (
  //   <SortableBody
  //     useDragHandle
  //     disableAutoscroll
  //     helperClass='row-dragging'
  //     onSortEnd={onSortEnd}
  //     {...props}
  //   />
  // );

  // const DraggableBodyRow = ({ className, style, ...restProps }) => {
  //   const index = data.findIndex(
  //     (x) => x.position == restProps['data-row-key']
  //   );

  //   return <SortableItem index={index} {...restProps} />;
  // };

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Row justify="center" className="">
      <Col xxl={24} xl={24} lg={24} md={24} className="heading-col">
        <Row align="middle" gutter={[30, 0]}>
          <Col>
            <div>
              <span className="heading-span">Curriculums</span>
            </div>
          </Col>
          <Col>
            <Button
              icon={<PlusOutlined />}
              // className='add-status-btn'
              size="small"
              disabled={isAdding}
              onClick={handleAdd}
            >
              CURRICULUM
            </Button>
          </Col>
        </Row>
      </Col>

      <Col lg={23} xl={22} xxl={22} md={24} style={{ minHeight: "20vh" }}>
        <Form
          form={form}
          component={false}
          onFinish={handleFinish}
          className="table-style"
        >
          <Table
            className="special-table activity-type-table project-statuses-table"
            components={{
              body: {
                cell: EditableCell,
                // wrapper: DraggableContainer,
                // row: DraggableBodyRow,
              },
            }}
            scroll={{ x: !fetchingLoading }}
            rowClassName="editable-row"
            dataSource={data}
            loading={fetchingLoading}
            columns={mergedColumns}
            pagination={false}
            rowKey="position"
          />
        </Form>
      </Col>
    </Row>
  );
};

export default CurriculumsTable;
